import { defineComponent as Z, openBlock as t, createElementBlock as o, mergeProps as A, unref as e, renderSlot as V, createElementVNode as l, createCommentVNode as d } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, p = { key: 1 }, u = { key: 2 }, M = { key: 3 }, g = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconBatteryVerticalLow"
}, _ = /* @__PURE__ */ Z({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(h) {
    const r = h, { bind: s, weight: n } = i(r);
    return (H, a) => (t(), o("svg", A({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      V(H.$slots, "default"),
      e(n) === "bold" ? (t(), o("g", m, a[0] || (a[0] = [
        l("path", { d: "M92,12A12,12,0,0,1,104,0h48a12,12,0,0,1,0,24H104A12,12,0,0,1,92,12ZM204,60V228a28,28,0,0,1-28,28H80a28,28,0,0,1-28-28V60A28,28,0,0,1,80,32h96A28,28,0,0,1,204,60Zm-24,0a4,4,0,0,0-4-4H80a4,4,0,0,0-4,4V228a4,4,0,0,0,4,4h96a4,4,0,0,0,4-4ZM156,192H100a12,12,0,0,0,0,24h56a12,12,0,0,0,0-24Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (t(), o("g", p, a[1] || (a[1] = [
        l("path", {
          d: "M192,56V224a16,16,0,0,1-16,16H80a16,16,0,0,1-16-16V56A16,16,0,0,1,80,40h96A16,16,0,0,1,192,56Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M88,8a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,8ZM200,56V224a24,24,0,0,1-24,24H80a24,24,0,0,1-24-24V56A24,24,0,0,1,80,32h96A24,24,0,0,1,200,56Zm-16,0a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8V224a8,8,0,0,0,8,8h96a8,8,0,0,0,8-8ZM160,192H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : e(n) === "fill" ? (t(), o("g", u, a[2] || (a[2] = [
        l("path", { d: "M88,8a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,8Zm72,176H96a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V192A8,8,0,0,0,160,184ZM200,56V224a24,24,0,0,1-24,24H80a24,24,0,0,1-24-24V56A24,24,0,0,1,80,32h96A24,24,0,0,1,200,56Zm-16,0a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8V224a8,8,0,0,0,8,8h96a8,8,0,0,0,8-8Z" }, null, -1)
      ]))) : e(n) === "light" ? (t(), o("g", M, a[3] || (a[3] = [
        l("path", { d: "M90,8a6,6,0,0,1,6-6h64a6,6,0,0,1,0,12H96A6,6,0,0,1,90,8ZM198,56V224a22,22,0,0,1-22,22H80a22,22,0,0,1-22-22V56A22,22,0,0,1,80,34h96A22,22,0,0,1,198,56Zm-12,0a10,10,0,0,0-10-10H80A10,10,0,0,0,70,56V224a10,10,0,0,0,10,10h96a10,10,0,0,0,10-10ZM160,194H96a6,6,0,0,0,0,12h64a6,6,0,0,0,0-12Z" }, null, -1)
      ]))) : e(n) === "regular" ? (t(), o("g", g, a[4] || (a[4] = [
        l("path", { d: "M88,8a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,8ZM200,56V224a24,24,0,0,1-24,24H80a24,24,0,0,1-24-24V56A24,24,0,0,1,80,32h96A24,24,0,0,1,200,56Zm-16,0a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8V224a8,8,0,0,0,8,8h96a8,8,0,0,0,8-8ZM160,192H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : e(n) === "thin" ? (t(), o("g", f, a[5] || (a[5] = [
        l("path", { d: "M92,8a4,4,0,0,1,4-4h64a4,4,0,0,1,0,8H96A4,4,0,0,1,92,8ZM196,56V224a20,20,0,0,1-20,20H80a20,20,0,0,1-20-20V56A20,20,0,0,1,80,36h96A20,20,0,0,1,196,56Zm-8,0a12,12,0,0,0-12-12H80A12,12,0,0,0,68,56V224a12,12,0,0,0,12,12h96a12,12,0,0,0,12-12ZM160,196H96a4,4,0,0,0,0,8h64a4,4,0,0,0,0-8Z" }, null, -1)
      ]))) : d("", !0)
    ], 16));
  }
});
export {
  _ as default
};
